export enum EFinancialAccountOperation {
    ENTRADA = 'ENTRADA',
    SAIDA = 'SAIDA',
}
